import { useEffect, useState } from "react";
import { apiFetch } from "../lib/api.js";

export default function FloorEditor({ showIllustration = true }) {
  const [content, setContent] = useState(null);
  const [selected, setSelected] = useState([]);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    Promise.all([apiFetch("/content/diagnostic"), apiFetch("/floor")]).then(([diag, floorRes]) => {
      setContent(diag);
      if (floorRes.floor && floorRes.floor.length) {
        setSelected(floorRes.floor.map((f) => f.label));
      }
    });
  }, []);

  if (!content) return null;

  function toggle(label) {
    setSaved(false);
    setSelected((prev) => (prev.includes(label) ? prev.filter((l) => l !== label) : [...prev, label]));
  }

  async function save() {
    setError(null);
    const floor = content.floors.filter((f) => selected.includes(f.label));
    try {
      await apiFetch("/floor", { method: "PUT", body: { floor } });
      setSaved(true);
    } catch (e) {
      setError(e.message);
    }
  }

  return (
    <div>
      <p style={{ color: "var(--muted)", marginBottom: 24 }}>
        Pick three to five. This is what still counts as holding the line in your worst week.
      </p>

      <div className="choice-list" style={{ marginTop: 0 }}>
        {content.floors.map((f) => (
          <button
            key={f.label}
            className={selected.includes(f.label) ? "selected" : ""}
            onClick={() => toggle(f.label)}
          >
            <div>{f.label}</div>
            <div style={{ color: "var(--muted)", fontSize: 13, marginTop: 4 }}>{f.detail}</div>
          </button>
        ))}
      </div>

      <div style={{ marginTop: 24, color: "var(--muted)", fontSize: 13.5 }}>{selected.length} selected</div>
      {error && <p style={{ color: "var(--error)", marginTop: 12 }}>{error}</p>}
      {saved && <p style={{ color: "var(--hold)", marginTop: 12 }}>Floor saved.</p>}

      <button className="btn-primary" style={{ marginTop: 24 }} onClick={save}>
        Save floor
      </button>
    </div>
  );
}
